export function userSignedUpWithSSO(user: UserState) {
  if (user.auth0_id.includes("auth0")) {
    return true;
  } else {
    return false;
  }
}
